import { action } from '@ember/object';

import type { PopupData } from 'webapp-types';

import CommonUiIconComponent from 'webapp/components/common/ui-icon';
import PopupInnerModalComponent from 'webapp/components/popup/inner/modal';
import ReportsShareSendLaterFormComponent from 'webapp/components/reports/share/send-later-form';

export default class ReportSchedulesPopupSendLaterComponent extends PopupInnerModalComponent<PopupData.ReportSchedule.SendLater> {
	@action
	save(ts: number): Promise<void> {
		return this.popupData.onSave(ts).then(() => {
			this.close();
		});
	}
	<template>
		<div class="title">
			<CommonUiIconComponent @name="Hourglass" @size="lg" />
			Send later
		</div>
		<div class="content">
			<ReportsShareSendLaterFormComponent
				@initialTimestamp={{this.popupData.initialTimestamp}}
				@onSave={{this.save}}
				@onClose={{this.close}}
				@onContentChange={{this.reposition}}
			/>

		</div>
	</template>
}
